import { render, staticRenderFns } from "./user_import_file_uploader.vue?vue&type=template&id=9b5d48b2&"
import script from "./user_import_file_uploader.vue?vue&type=script&lang=js&"
export * from "./user_import_file_uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports